var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: column;\n'], ['\n  display: flex;\n  flex-direction: column;\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  box-sizing: border-box;\n  border-radius: ', ' !important;\n  border: ', ' solid #ddd;\n  min-height: 48px;\n  margin-top: 0px;\n  padding: 16px;\n  transition: all 0.25s ease-in-out;\n  font-size: 1rem;\n  line-height: 1.5625rem;\n  &:focus {\n    outline: 0;\n    border: 1px solid ', ';\n  }\n  &::placeholder {\n    color: #bbb;\n  }\n'], ['\n  box-sizing: border-box;\n  border-radius: ', ' !important;\n  border: ', ' solid #ddd;\n  min-height: 48px;\n  margin-top: 0px;\n  padding: 16px;\n  transition: all 0.25s ease-in-out;\n  font-size: 1rem;\n  line-height: 1.5625rem;\n  &:focus {\n    outline: 0;\n    border: 1px solid ', ';\n  }\n  &::placeholder {\n    color: #bbb;\n  }\n']);

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React from 'react';
import styled from 'styled-components';
import InputContainer from '../InputContainer';
import Label from '../Label';
var StyledTextAreaContainer = styled.div(_templateObject);
var Input = styled.textarea(_templateObject2, function (props) {
  return props.theme.radius;
}, function (props) {
  return props.theme.border_width;
}, function (props) {
  return props.theme.colours.primary.base;
});

var TextArea = function (_React$Component) {
  _inherits(TextArea, _React$Component);

  function TextArea() {
    _classCallCheck(this, TextArea);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  TextArea.prototype.render = function render() {
    var _props = this.props,
        label = _props.label,
        rest = _objectWithoutProperties(_props, ['label']);

    return React.createElement(InputContainer, null, React.createElement(StyledTextAreaContainer, null, React.createElement(Label, null, label), React.createElement(Input, _extends({}, rest, {
      'aria-label': label
    }))));
  };

  return TextArea;
}(React.Component);

export { TextArea as default };